import {get as getProjection} from 'ol/proj.js';
import {Point} from "ol/geom";
import {boundingExtent} from "ol/extent";
import {Fill, Stroke, Style} from "ol/style";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {GeoJSON} from "ol/format";
import CircleStyle from "ol/style/Circle";

const DEFAULT_PARAMS = {
    'format': 'jsonv2',
    'countrycodes': 'ch',
    'layer': 'address'
}

const _SEARCH_RESULT_COLOR = '#880ab2'
const _SEARCH_RESULT_COLOR_T = `${_SEARCH_RESULT_COLOR}19`
const _SEARCH_RESULT_STROKE_WIDTH = 1

const image = new CircleStyle({
  radius: 5,
  fill: new Fill({
            color: _SEARCH_RESULT_COLOR_T,
        }),
  stroke: new Stroke({
      color: _SEARCH_RESULT_COLOR,
      width: _SEARCH_RESULT_STROKE_WIDTH
  }),
});

const SEARCH_RESULT_STYLE = {
    'Polygon': new Style({
        stroke: new Stroke({
            color: _SEARCH_RESULT_COLOR,
            width: _SEARCH_RESULT_STROKE_WIDTH,
        }),
        fill: new Fill({
            color: _SEARCH_RESULT_COLOR_T,
        })
    }),
    'LineString': new Style({
        stroke: new Stroke({
            color: _SEARCH_RESULT_COLOR,
            width: _SEARCH_RESULT_STROKE_WIDTH,
        }),
    }),
    'Point': new Style({
        image: image
    })
}

const styleFunction = function(feature) {
    return SEARCH_RESULT_STYLE[feature.getGeometry().getType()]
}

export default class AddressSearch {
    constructor(nominatimUrl, map, maxZoom, useDisplayLayer = true) {
        this.nominatimUrl = nominatimUrl
        /** @type {Map} */
        this.map = map
        this.maxZoom = maxZoom

        this.nominatimProj = getProjection('EPSG:4326')

        this.useDisplayLayer = useDisplayLayer

        if (useDisplayLayer) {
            this._setupDisplayLayer()
        }
    }

    _setupDisplayLayer() {
        const vectorSource = new VectorSource({})
        this.vectorSource = vectorSource

        this.resultLayer = new VectorLayer({
            source: vectorSource,
            style: styleFunction,
        })
    }

    attachSearchForm(form) {
        form.addEventListener('submit', (event) => {
            event.preventDefault()
            const input = form.querySelector('input[name=search]')
            this.performSearchAndPan(input.value).catch(e => console.error(e))
        })
    }

    async performSearchAndPan(query) {
        const results = await this._callNominatim(query)
        if (results.length === 0) {
            console.log('no result found')
            return false
        }

        const result = results[0]
        const rBBox = result.boundingbox.map(parseFloat)


        const p1 = new Point([rBBox[2], rBBox[0]])
        const p2 = new Point([rBBox[3], rBBox[1]])
        p1.transform(this.nominatimProj, this.map.getView().getProjection())
        p2.transform(this.nominatimProj, this.map.getView().getProjection())

        const bbox = boundingExtent([p1.getCoordinates(), p2.getCoordinates()])

        // console.log(bbox)

        this.map.getView().fit(bbox, {
            maxZoom: this.maxZoom,
            duration: 150
        })

        if (this.useDisplayLayer) {
            this._updateResultLayer(result.geojson)
        }
    }

    _callNominatim(query) {
        const params = new URLSearchParams(DEFAULT_PARAMS)
        params.append('polygon_geojson', '1')
        params.append('q', query)

        const url = `${this.nominatimUrl}?${params.toString()}`
        return fetch(url)
            .then(response => response.json())
    }

    _updateResultLayer(geojson) {
        const features = new GeoJSON().readFeatures(geojson)

        features.forEach(f => f.getGeometry().transform(this.nominatimProj, this.map.getView().getProjection()))

        const source = new VectorSource({
            features: features
        })


        this.resultLayer.setSource(source)
    }
}
